enum NftKind {
  Generative = "Generative",
  MasterEditionWithNonzeroSupply = "MasterEditionWithNonzeroSupply",
  MasterEditionWithUnlimitedSupply = "MasterEditionWithUnlimitedSupply",
  OneOfOne = "OneOfOne",
  PnftMasterEdition = "PnftMasterEdition",
  PnftStandardEdition = "PnftStandardEdition",
  StandardEditionPrintNonzeroSupply = "StandardEditionPrintNonzeroSupply",
  StandardEditionPrintUnlimitedSupply = "StandardEditionPrintUnlimitedSupply",
}

export default NftKind;
